/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-06-30 20:30:30
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2024-12-25 16:20:18
 */
import Cookie from 'js-cookie';
import { setup_locale } from '@/lang';
import ls from "@/utils/Ls"
const mutations = {
  // keycloak
  SET_KEYCLOAK: (state, keycloak) => {
    state.keycloak = keycloak;
    ls.set("base-application-keycloak", keycloak);
  },
  SET_KEYCLOAK_ThirdPartyLogin: (state, isThirdPartyLogin) => {
    state.is_third_party_login = isThirdPartyLogin;
    ls.set("base-application-isThirdPartyLogin", isThirdPartyLogin);
  },
  //上传附件方式
  set_sys_upload_type(state, value) {
    ls.set('sys_upload_type', JSON.stringify(value || {}));
    state.sys_upload_type = value;
  },
  //页面title
  set_page_title(state, value) {
    ls.set('page_title', JSON.stringify(value || ''));
    state.page_title = value;
  },
  // 保存token
  set_token(state, token_info) {
    ls.set('token', token_info.token? token_info.token:null, token_info.token_expires_in?token_info.token_expires_in : (86400 * 1000));
    state.token = token_info.token? token_info.token:null
  },
  // 保存列表页的每一项
  set_listObj(state, value) {
    sessionStorage.setItem('listObj', JSON.stringify(value) || '{}');
    state.listObj = value;
  },
  // 保存菜单列表
  set_sideMenu(state, value) {
    sessionStorage.setItem('sideMenu', JSON.stringify(value) || '[]');
    state.sideMenu = value;
  },
  set_userData(state, value) {
    ls.set('userData', JSON.stringify(value) || '{}');
    state.userData = value;
  },
  set_homeUrlList(state, value) {
    ls.set('homeUrlList', JSON.stringify(value) || '[]');
    state.homeUrlList = value;
  },
  set_topcompanylist(state, value) {
    sessionStorage.setItem('topcompanylist', JSON.stringify(value) || '[]');
    state.topcompanylist = value;
  },
  set_miniVariant(state, value) {
    state.miniVariant = value;
  },
  set_iconstatus(state, value) {
    ls.set('iconstatus', JSON.stringify(value));
    state.iconstatus = value;
  },
  set_subPage_name(state, value) {
    ls.set(
      'subPage_name',
      JSON.stringify(value) ? JSON.stringify(value) : ''
    );
    state.subPage_name = value;
  },
  set_group_name(state, value) {
    ls.set(
      'group_name',
      JSON.stringify(value) ? JSON.stringify(value) : ''
    );
    state.group_name = value;
  },
  set_product_uuid(state, value) {
    ls.set('product_uuid', JSON.stringify(value || ''));
    state.product_uuid = value;
  },
  set_uuid(state, value) {
    ls.set('uuid', JSON.stringify(value || ''));
    state.uuid = value;
  },
  set_uuid2(state, value) {
    ls.set('uuid2', JSON.stringify(value || ''));
    state.uuid2 = value;
  },
  set_version_uuid(state, value) {
    ls.set('version_uuid', JSON.stringify(value || ''));
    state.version_uuid = value;
  },
  set_client_type(state, value) {
    ls.set('client_type', JSON.stringify(value) || '[]');
    state.client_type = value;
  },
  set_version(state, value) {
    ls.set('version', JSON.stringify(value || ''));
    state.version = value;
  },
  set_currentCompany(state, value) {
    if (value) {
      ls.set('currentCompany', JSON.stringify(value || ''));
      state.currentCompany = value;
    } else {
      ls.set('currentCompany', JSON.stringify(''));
      state.currentCompany = '';
    }
  },
  // 客户管理id
  set_detailuuid(state, value) {
    ls.set('detailuuid', JSON.stringify(value || ''));
    state.detailuuid = value;
  },
  set_detailclientname(state, value) {
    ls.set('detailclientname', JSON.stringify(value || ''));
    state.detailclientname = value;
  },
  // 保存添加 客户联系人列表
  set_clientcontacts(state, value) {
    state.clientcontacts = value;
  },
  newsTips(state, value) {
    state.snackbar_open = true;
    state.newsText = value;
  },
  set_change(state, value) {
    ls.set('is_change', value);
    state.is_change = value;
  },
  set_nested_flag(state, value) {
    state.nested_flag = value;
  },
  set_loginStatus(state, value) {
    //登录状态
    state.loginStatus = value;
  },
  // 切换语言
  set_lang(state, value) {
    state.lang = value.value;
    state.lang_name = value.text;
    ls.set('localeLanguage', value.value);
    ls.set('lang_name', value.text);

    state.currentCompanyLanguage.forEach((item) => {
      if (item.value == value.value) {
        item.is_default = 1;
      } else {
        item.is_default = 0;
      }
    });
    // ls.set('companyLang', JSON.stringify(state.currentCompanyLanguage))
    setup_locale(value.value || navigator.language);
  },
  setTab(state, value) {
    state.tab = value;
    // console.log(Boolean(JSON.stringify(value)), '---', value)
    // console.log((JSON.stringify(value)), '---')
    ls.set('tab', JSON.stringify(value));
    // console.log(ls.set('tab', JSON.stringify(value)) ? ls.set('tab', JSON.stringify(value)) : 0);
  },
  setTab2(state, value) {
    state.tab2 = value;
    ls.set('tab2', JSON.stringify(value || 0));
  },
  setOrgLevelCode(state, value) {
    state.orgLevelCode = value;
    ls.set('orgLevelCode', JSON.stringify(value || ''));
  },
  // setAllLanguage (state, value) {
  //   ls.set('allLanguage', JSON.stringify(value))
  //   state.allLanguage = value
  // },
  setCurrentCompanyLanguage(state, value) {
    state.currentCompanyLanguage = value;
    ls.set(
      'currentCompanyLanguage',
      JSON.stringify(value) || '[]'
    );
  },
  set_languageList(state, value) {
    state.languageList = value;
    if(state.token)
    ls.set('languageList', JSON.stringify(value) || '{}');
  },
  setCurrentCopmpanyMenu(state, value) {
    state.currentCopmpanyMenu = value;
    ls.set('currentCopmpanyMenu', JSON.stringify(value) || '[]');
  },
  setMenuFunctionUuid(state, value) {
    state.menuFunctionUuid = value;
    ls.set('menuFunctionUuid', value || '');
  },
  setBtnPermission(state, value) {
    state.btnPermission = value;
    ls.set('btnPermission', JSON.stringify(value) || '[]');
  },
  set_currentCompanyClientUuid(state, value) {
    state.currentCompanyClientUuid = value;
    ls.set('currentCompanyClientUuid', value || '');
  },
  // 重置state
  resetState(state) {
    ls.set('token', '');
    const obj = {
      token: ls.get('token') || '', // token
      sideMenu: JSON.parse(sessionStorage.getItem('sideMenu')) || [], // 菜单列表
      userData: JSON.parse(ls.get('userData')) || {}, // 菜单列表
      miniVariant: false, // 折叠菜单
      product_uuid: JSON.parse(ls.get('product_uuid')) || '', //产品id
      subPage_name: JSON.parse(ls.get('subPage_name')) || '', // 高级参照跳页面需要的参数，保存在本地，刷新会null
      uuid: JSON.parse(ls.get('uuid')) || '', // 详情页面需要的参数，保存在本地，刷新会null
      uuid2: JSON.parse(ls.get('uuid2')) || '', // 详情页面需要的参数，保存在本地，刷新会null
      currentCompany: JSON.parse(ls.get('currentCompany')) || '', //头部当前用户选择的company
      is_change: ls.get('is_change') || '', // 1.  有删除当前列的权限
      snackbar_open: false,
      snackbar_timeout: 1500,
      newsText: '',
      nested_flag: false, // 嵌套 单个打开
      lang:
        ls.get('localeLanguage') ||
        navigator.language ||
        navigator.userLanguage, // 全局管理语言
      lang_name: ls.get('lang_name') || '简体中文',
      detailuuid: JSON.parse(ls.get('detailuuid')) || '', //客户详情用户uuid，保存在本地，刷新会null
      clientcontacts: {}, //  客户详情联系人列表
      detailclientname:
        JSON.parse(ls.get('detailclientname')) || '', //客户详情用户clientname
      iconstatus:
        JSON.parse(ls.get('iconstatus')) == false ? false : true, //图标状态  默认为显示
      tab: JSON.parse(ls.get('tab')) || 0, // 所有tab 从这里找打开哪一个
      tab2: JSON.parse(ls.get('tab2')) || 0,
      orgLevelCode: JSON.parse(ls.get('orgLevelCode')) || null,
      topcompanylist:
        JSON.parse(sessionStorage.getItem('topcompanylist')) || [],
      pageSize: 20, // table 每页显示条数
      cpage: JSON.parse(sessionStorage.getItem('cpage')) || 1,
      client_type: JSON.parse(ls.get('client_type')) || '',
      version: JSON.parse(ls.get('version')) || '',
      // allLanguage: JSON.parse(ls.get('allLanguage')) || [],
      currentCompanyLanguage:
        JSON.parse(ls.get('currentCompanyLanguage')) || [],
      loginStatus: undefined, //用户第一次进入状态
      languageList: JSON.parse(ls.get('languageList')) || {}, // 当前语言的国际化翻译
      currentCopmpanyMenu:
        JSON.parse(ls.get('currentCopmpanyMenu')) || [], // 左侧权限菜单
      menuFunctionUuid: ls.get('menuFunctionUuid') || '', // 每一个菜单的
      currentCompanyClientUuid:
        ls.get('currentCompanyClientUuid') || '',
      pubk: ls.get('pubk') || '', // 加密公钥
      allMenuUrlList:
        JSON.parse(sessionStorage.getItem('allMenuUrlList')) || [],
      currentCompanyObj: [],
    };
    for (var i in obj) {
      state[i] = obj[i];
    }
  },
  setCurrentCompanyObj(state, val) {
    state.currentCompanyObj = val;
    ls.set('currentCompanyObj', JSON.stringify(val));
  },
  setAllMenuUrlList(state, val) {
    state.allMenuUrlList = [val, ...state.allMenuUrlList];
    sessionStorage.setItem(
      'allMenuUrlList',
      JSON.stringify(state.allMenuUrlList)
    );
  },
  setCalcHeight(state, value) {
    state.calcHeight = value;
  },
  setCpage(state, value) {
    state.cpage = value;
    sessionStorage.setItem('cpage', JSON.stringify(value || 1));
  },
  setPagesize(state, value) {
    state.pageSize = value;
    sessionStorage.setItem('pageSize', JSON.stringify(value || 10));
  },
  setPubk(state, value) {
    state.pubk = value;
    sessionStorage.setItem('pubk', value);
  },
};

export default mutations;
